import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesFR: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    DOCTOR: 'Médecin',
    NURSE: 'Infirmière',
    OTHER_HEALTH_WORKER: 'Autres professionnels de la santé',
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: "Pour pouvoir bénéficier de cette offre, vous devez (1) être un professionnel de la santé actuellement autorisé à exercer et (2) être membre d'une branche éligible de la profession médicale. Les succursales éligibles sont indiquées dans le sélecteur Statut\n de ce formulaire.<br><br>{companyName} utilise SheerID, un partenaire de confiance, pour vérifier que vous êtes un professionnel de la santé.\n SheerID ne collecte que les informations qui aident à vérifier votre éligibilité.\n Des informations ou documents supplémentaires peuvent être demandés. ",
        },
        success: {
            verificationOnly: "SheerID s'occupe uniquement de la vérification. Maintenant que votre dossier a été approuvé, veuillez adresser toutes vos questions concernant les conditions de la promotion et/ou l’utilisation du code au service clientèle de <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a>.",
        },
        error: {
            redirectButtonText: 'CONTINUER À TIMBERLAND',
        },
    },
};
